import React, { useEffect } from 'react';
import { Modal } from 'antd';
import PlatformTableComponent from '../../components/platformTableComponent/platformTableComponent';
import { AccessLevel } from '../../types/types';

interface Props {
  onCancel: Function,
  onSelection: Function,
  fieldId: string,
  dataTableBluePrint: string,
  searchBluePrint: string,
  moduleCode?: string,
  title?: string

}

const SearchableField: React.FC<Props> = (
  { onCancel,
    onSelection,
    fieldId,
    dataTableBluePrint,
    searchBluePrint,
    moduleCode = "UNKNOWN",
    title = "Search"
  }) => {

  const handleOnFieldSelectEvent = (event: any) => {
    const field: string = event.detail.field;
    const value: string = event.detail.value;
    if(field === fieldId){
      onSelection(value);
    }
  }

  useEffect(() => {
    document.addEventListener('onSearchFieldSelect', handleOnFieldSelectEvent);
    // setWaiverHeadFieldAmount(waiverHeadFieldAmounts.find(amountField => amountField.key === actualDueField.field) ?? { ...waiverHeadFieldAmount });
    return () => {
      document.removeEventListener('onSearchFieldSelect', handleOnFieldSelectEvent);
    };
  }, []);

  return (
    <Modal
      // title={title}
      visible={true}
      onCancel={() => onCancel()}
      footer={null}
      width={"80%"}     
      style={{overflowX: "auto"}}
      
    >
      <PlatformTableComponent
        bluePrintApi={dataTableBluePrint}
        searchApi={searchBluePrint}
        moduleCode={moduleCode}
        title={title}
        openInFieldSearchModal={true}
        searchFieldKey={fieldId}
        moduleAccessLevel={"READ" as AccessLevel}
      />
    </Modal>
  );
};

export default SearchableField;
